module.exports = __webpack_public_path__ + "static/img/Square_Tool.bd296cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/Square_Tool.png
// module id = 1106
// module chunks = 21